import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmModal.css';

function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();

  if (!isOpen) return null;
  return (
    <div className="confirmModalOverlay" onClick={onCancel}>
      <div className="confirmModalBox" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirmModalTitle">{title}</h3>
        <p className="confirmModalMessage">{message}</p>
        <div className="confirmModalActions">
          <button
            type="button"
            className="confirmModalBtn cancel"
            onClick={onCancel}
          >
            {cancelLabel || t('common.cancel')}
          </button>
          <button
            type="button"
            className="confirmModalBtn confirm"
            onClick={onConfirm}
          >
            {confirmLabel || t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
